// src/contexts/JobContext.js (crear este archivo nuevo)
import React, { createContext, useContext, useState, useEffect } from 'react';
import supabase from '../supabase';

const JobContext = createContext();

export const JobProvider = ({ children }) => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalApplications, setTotalApplications] = useState(0);

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        setLoading(true);

        const { data: { user }, error: userError } = await supabase.auth.getUser();
        if (userError) throw userError;

        const { data: jobData, error: jobError } = await supabase
          .from('job_offers')
          .select(`
            id,
            title,
            location,
            remote_allowed,
            status,
            created_at,
            views_count,
            category
          `)
          .eq('creator_id', user.id)
          .eq('creator_type', 'company')
          .order('created_at', { ascending: false });

        if (jobError) throw jobError;

        const jobsWithApplicationsCount = await Promise.all(
          jobData.map(async (job) => {
            const { count, error } = await supabase
              .from('job_applications')
              .select('id', { count: 'exact', head: true })
              .eq('job_id', job.id);

            if (error) {
              console.error('Error al contar aplicaciones:', error);
              return { ...job, applications_count: 0 };
            }

            return { 
              ...job, 
              applications_count: count || 0,
              is_active: job.status === 'active'
            };
          })
        );

        const totalApps = jobsWithApplicationsCount.reduce((sum, job) => sum + job.applications_count, 0);
        setTotalApplications(totalApps);
        setJobs(jobsWithApplicationsCount);
      } catch (error) {
        console.error('Error al cargar ofertas:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchJobs();
  }, []);

  return (
    <JobContext.Provider value={{ jobs, loading, totalApplications }}>
      {children}
    </JobContext.Provider>
  );
};

export const useJobs = () => useContext(JobContext);